module.exports = __webpack_public_path__ + "static/media/Business101.a9bd915e.JPG";